import PaymentMethodCard from './PaymentMethodCard.component';

export default PaymentMethodCard;
